import React from "react";
import FixedView from "../../FixedView";
// import { Draggable } from "react-beautiful-dnd";
// import { getBoundingClientRect } from '../../../utils/functions';
// import TextAreaInput from '../../../components/inputs/TextAreaInput';
export default class TaskItem extends React.Component {

    state = {
        rename: false,

        moreOoption: [
            { title: "Set Priority", icon: "/assets/icons/bolt.svg" },
            { title: "Rename Task", icon: "/assets/icons/highlighter.svg" },
            { title: "View Details", icon: "/assets/icons/highlighter.svg" },
        ],
        PriorityList: [
            { title: "High", background: "red" },
            { title: "Medium", background: "orange" },
            { title: "Low", background: "#31c131" },
        ],
        done: false,
        detail: false,
        background: this.props.taskColor
    }
    renameRef = React.createRef();
    more = React.createRef();
    priority = React.createRef();
    priorityList = React.createRef();
    setPositionDiv = React.createRef();
    moreOoption = React.createRef();
    componentDidUpdate() {
        if (!this.state.rename) {
            document.addEventListener('keypress', this.onKeyPress)
        }
    }
    openmoremenu = () => {
        this.more.showView()
    }
    OnMoreOption = (item) => {
        if (item == 'Rename Task')
            this.rename();
        if (item == 'Set Priority')
            this.priority.showView();
        if (item == 'View Details') {
            this.props.showDetail(true)
            this.more.hideView();
            this.props.getStatus(this.state.done)
        }
    }

    OnPriority = (priority) => {
        if (priority == 'High')
            this.setState({ background: "red" })
        if (priority == 'Medium')
            this.setState({ background: "orange" })

        if (priority == 'Low')
            this.setState({ background: "#31c131" })


    }
    rename = () => {
        this.setState({ rename: true })
    }
    markComplete = () => {
        this.setState({ done: !this.state.done })
        this.more.hideView();
    }
    clickTimeOut = null;
    onDoubleClickHandler = () => {
        if (this.clickTimeOut !== null) {
            clearTimeout(this.clickTimeOut)
            this.clickTimeOut = null;
            return;
        }
        this.clickTimeOut = setTimeout(() => {
            clearTimeout(this.clickTimeOut)
            this.clickTimeOut = null;
        }, 1000);
        this.setState({ addSubject: true })
        this.rename();
    };
    onKeyPress = (event) => {
        console.log(event.key, "enter")
        if (event.key === "Enter") {
            console.log("Enter Key Press");
            document.removeEventListener('keypress', this.onKeyPress);
            const name = this.renameRef.current.value;
            console.log(name, "name")
            this.props.renameTask(name, this.props.taskId, this.props.taskDate, this.props.taskColor);
            this.setState({ rename: false })
        }
    }
    render() {
        return (
            <>

                {this.props.addTask &&
                    <div className="week-day br-8 mb-2" style={{
                        boxShadow: "rgba(0, 0, 0, 0.1) 0px 1px 2px 0px",
                        alignItems: 'center', backgroundColor: this.state.background,
                        opacity: this.state.done ? "66%" : "100%",
                        padding: "3px 5px", height: "fit-content"

                    }}>

                        <div >
                            {!this.state.rename ?
                                <div className="task-item flexcc">
                                    <div className="done" style={{minWidth:this.state.done?"45px":"22px"}}>
                                        <div className="tasktem-img" onClick={() => this.setState({ done: !this.state.done })}
                                            style={{ background: this.state.done ? "green" : "transparent", marginRight: "4px" }}>
                                            <img src="/assets/icons/Vector 1.svg" width={13} style={{ marginBottom: "1px" }} />
                                        </div>
                                        {this.state.done &&
                                            <img src="/assets/icons/Vector 1.svg" width={13} />
                                        }
                                    </div>
                                    <div className="w-100" style={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between", alignItems: 'left' }}>
                                        <p className="font-size-12 pld-1" style={{ color: '#000', wordBreak: "break-word" }} onClick={() => this.onDoubleClickHandler()}>{this.props.name}</p>
                                        <div>
                                            <button className='' onClick={() => this.openmoremenu()} ref={el => this.moreOption = el}>

                                                <img width={18} style={{ transform: "rotate(90deg" }} src="/assets/icons/more-black.svg" />
                                            </button>


                                        </div>
                                    </div>
                                </div>
                                :
                                <input type="text" className='br-4 font-size-12' style={{ border: "none", padding: "2px", backgroundColor: "#ffffff59", maxWidth: "74px" }} placeholder={"new name"} defaultValue={this.props.name} ref={this.renameRef} />
                            }


                        </div>

                    </div>

                }

                <FixedView ref={el => this.more = el} nodeRef={this.moreOption} showFocus={false} topOffset={7} xOffset={0} zIndex={300}>
                    <div className='shadow-2 br-10 py-1 px-2 text-center' style={{ backgroundColor: "#fff", width: "171px" }} >
                        {this.state.moreOoption.map((prop, index) => {
                            return (
                                <button className=' px-2 flexc py-1 my-1 note-hover-box2 w-100 h-100 br-5'
                                    ref={el => this.priorityList = el}
                                    onClick={() => this.OnMoreOption(prop.title)}
                                >
                                    <img className='mrd-3 flexcc' src={prop.icon} />
                                    <p className='text-start des-color'>{prop.title}</p>
                                </button>
                            )
                        })}
                        <button className='px-2 flexc py-1 my-1 note-hover-box2 w-100 h-100 br-5' >
                            <img className='mrd-3 flexcc opacity-5' src='/assets/icons/applets/desk/airpod.left.svg' />
                            <p className='text-start des-color'
                                onClick={() => this.markComplete()}
                            >
                                {!this.state.done ?
                                    "Mark Complete"
                                    :
                                    "mark Incomplete"
                                }</p>
                        </button>
                        <div className='mx-2' style={{ borderTop: "1px solid #c8c8c8" }}>
                        </div>
                        <button className='px-2 flexc py-1 my-1 note-hover-box2 w-100 h-100 br-5' >
                            <img className='mrd-3 flexcc' src='/assets/icons/trash.svg' />
                            <p className='text-start' style={{ color: "#EF1919" }}
                                onClick={() => this.props.removeTask(this.props.name, this.props.taskDate, this.props.taskColor)}
                            >Delete section</p>
                        </button>
                    </div>
                </FixedView>
                <FixedView ref={el => this.priority = el} nodeRef={this.priorityList} showFocus={false} topOffset={0} xOffset={-160} zIndex={300}>

                    <div className='shadow-2 br-10 py-1 px-2' style={{ backgroundColor: "#fff", width: "85px" }}>

                        {this.state.PriorityList.map((prop, index) => {
                            return (
                                <button className='px-2 flexc py-1 my-1 note-hover-box2 w-100 h-100 br-5'
                                    style={{ background: prop.background }}
                                    onClick={() => this.OnPriority(prop.title)}
                                >
                                    <p className='text-start des-color'>{prop.title}</p>
                                </button>
                            )
                        })}
                    </div>
                </FixedView>

            </>
        )
    }

}